import { CitationMatchTable } from 'components/citation-match-table';
import { Link } from 'components/link';
import { Section } from 'components/section';
import { CitationResponse, DocumentResponse } from 'types/api-responses';

import style from './target-citation-match-section.module.scss';

type TargetCitationMatchSectionProps = {
  document: DocumentResponse;
  documentType: string;
  header?: string;
  provisionField: string;
  extractedColumnHeader: string;
  extractedColumnTooltip: string;
  matchColumnHeader: string;
  testId: string;
  renderTargetType: (
    target: NonNullable<CitationResponse['regulatedTargets']>[number]
  ) => string | null | undefined;
  targetTypeLabel: string;
};

const TargetCitationMatchSection = ({
  document,
  documentType,
  header,
  provisionField,
  extractedColumnHeader,
  extractedColumnTooltip,
  matchColumnHeader,
  testId,
  renderTargetType,
  targetTypeLabel,
}: TargetCitationMatchSectionProps) => {
  if (document.type !== documentType) return null;

  const targetCitations =
    document.citations?.filter(
      (citation) => citation.provisionField === provisionField
    ) || [];

  if (targetCitations.length === 0) return null;

  const table = (
    <CitationMatchTable
      citations={targetCitations}
      extractedColumnHeader={extractedColumnHeader}
      extractedColumnTooltip={extractedColumnTooltip}
      matchColumnHeader={matchColumnHeader}
      testId={testId}
      renderMatch={(citation) => {
        if (citation.regulatedTargets && citation.regulatedTargets.length > 0) {
          return citation.regulatedTargets.map((target) => {
            const targetType = renderTargetType(target);

            return (
              <div key={target.id}>
                <Link to={target.href}>{target.displayName}</Link>
                {target.uwi && (
                  <div className={style.entityType}>UWI: {target.uwi}</div>
                )}
                {targetType && (
                  <div className={style.entityType}>
                    {targetTypeLabel}: {targetType}
                  </div>
                )}
              </div>
            );
          });
        }
        return '\u2014';
      }}
    />
  );

  return header ? <Section header={header}>{table}</Section> : table;
};

export { TargetCitationMatchSection };
